import React from 'react';
import { Outlet } from 'react-router-dom';

const PublicLayout = ({ children }) => {
    return (
        <div className="flex min-h-screen flex-col bg-canvas">
            <main className="flex-1 w-full">
                <Outlet />
            </main>
        </div>
    );
};

export default PublicLayout;
